import React from "react";
import { logger } from "@/utils/loggingUtils";
import { EukaBarkProvider, ErrorPage } from "@euka-mfes/bark";
import { getBaseRoute } from "@/utils/route";

interface State {
  hasError: boolean;
}

interface Props {
  children: React.ReactNode;
}

class AppErrorBoundary extends React.Component<Props, State> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logger.error("Unhandled React error caught by AppErrorBoundary", {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleDashboard = () => {
    window.location.href = getBaseRoute();
  };

  render() {
    if (this.state.hasError) {
      return (
        <EukaBarkProvider>
          <ErrorPage
            statusCode={500}
            bgPosition="full"
            statusTitle="Something went wrong"
            statusDescription="An unexpected error occurred. Please try reloading
              the page or return to the dashboard. If the problem persists,
              contact support."
            btnPrimaryText="Reload Page"
            onClickBtnPrimary={this.handleReload}
            btnSecondaryText="Return to dashboard"
            onClickBtnSecondary={this.handleDashboard}
          />
        </EukaBarkProvider>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
